module.exports = __webpack_public_path__ + "static/media/calendar.7516f297.svg";